<template>
	<v-dialog
		v-model="dialog"
		max-width="700px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				class="ml-2"
				:text="text"
				:color="text ? 'white' : 'secondary'"
				@click.stop="dialog = true"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-2">mdi-plus</v-icon>
				テンプレートを作成
			</v-btn>
		</template>

		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">日報テンプレート作成</v-app-bar-title>
				<v-spacer />
				<v-btn @click="dialog = false" icon>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-card-text class="pa-2">
				<v-form ref="form" v-model="valid">
					<TemplateForm
						:templateData.sync="template"
						:metaTypes="metaTypes"
						:polymorphicOptions="polymorphicOptions"
						:optionTypes="optionTypes"
					/>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-row no-gutters class="py-2">
					<v-col cols="0" sm="2"></v-col>
					<v-col cols="12" sm="8">
						<v-row no-gutters justify="center">
							<v-btn @click="submitForm" color="secondary" :disabled="!valid">
								<v-icon class="mr-2">mdi-plus</v-icon>
								作成する</v-btn
							>
						</v-row>
					</v-col>
					<v-col cols="0" sm="2">
						<v-row v-if="!$vuetify.breakpoint.xs" no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="dialog = false"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import TemplateForm from "./DailyReportTemplateForm.vue"
export default {
	props: {
		text: {
			type: Boolean,
			required: false,
			default: false,
		},
		metaTypes: {
			type: Array,
			required: true,
		},
		optionTypes: {
			type: Array,
			required: true,
		},
		polymorphicOptions: {
			type: Array,
			required: true,
		},
	},
	components: {
		TemplateForm,
	},
	data() {
		return {
			department_id: this.$route.params.department_id,
			dialog: false,
			valid: false,
			template: {
				name: null,
				daily_report_meta_keys_attributes: [],
			},
			errors: [],
		}
	},
	methods: {
		submitForm() {
			if (!this.$refs.form.validate()) return
			const headers = authenticate.setHeader()
			const url = `/erp/v1/departments/${this.department_id}/daily_report_templates`
			axios
				.post(url, { daily_report_template: this.template }, { headers })
				.then((res) => {
					this.$emit("add-template", res.data)
					this.dialog = false
					this.$refs.form.reset()
					this.$store.dispatch("setFlash", {
						text: "日報テンプレートを作成しました。",
						type: "notice",
					})
				})
				.catch((err) => {
					const error = errorHandling.errorResponse(err)
					if (Array.isArray(error)) {
						this.errors = error
					}
				})
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../../stylesheet/variable.scss";

.v-input--selection-controls {
	margin-top: 0;
}
</style>